import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CurrentProductService } from '@spartacus/storefront';
import { BehaviorSubject, Observable, Subscription, of } from 'rxjs';
import { catchError, map, switchMap, take, tap } from 'rxjs/operators';
import { DealerPrice } from 'src/app/model/dealer-price.model';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { SpecTablePayload, SpecTableService } from 'src/app/service/spec-table/spec-table.service';

@Component({
  selector: 'app-spec-table',
  templateUrl: './spec-table.component.html',
  styleUrls: ['./spec-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SpecTableComponent implements OnInit {
  specProductHeaders: any;
  specProductValues: any;
  specSKUCode: any[] = [];
  hasDealerPrice = true;
  dealerPrices: DealerPrice[];
  specTableLoadersubscription$: Subscription;
  public specTableData$ = new BehaviorSubject<any>(null);

  private getSpecTable(code: string): Observable<any> {
    const specTablePayload: SpecTablePayload = {
      fields: 'DEFAULT',
      productCode: code,
      productOptions: 'SPEC_TABLE',
    };
    return this.spectableService.getSpecTable(specTablePayload);
  }

  constructor(
    protected currentProductService: CurrentProductService,
    private spectableService: SpecTableService,
    private cdr: ChangeDetectorRef,
    private dealerPriceService: DealerPriceService,
    private languageService: ShimanoLanguageService
  ) {}

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  ngOnInit(): void {
    this.specTableLoadersubscription$ = this.currentProductService
      .getProduct()
      .pipe(
        switchMap((product: any) => {
          if (product && product.code) {
            return this.loadSpecTableData(product.code);
          } else {
            // If there's no product or product code, reset the spec table data.
            this.specTableData$.next(null);
            return of(null);
          }
        })
      )
      .subscribe();
  }

  loadSpecTableData(productCode: string): Observable<any> {
    return this.getSpecTable(productCode).pipe(
      map((data: any) => {
        let productLocalSKUCode: any = [];
        if (data && data.specTable) {
          this.specProductHeaders = data.specTable.productHeaders;
          this.specProductValues = data.specTable.productValues;
          if (this.specProductValues) {
            this.specProductValues.forEach((skucode: any) => {
              productLocalSKUCode.push(skucode.code);
            });
          }
          this.specTableData$.next(data);
          this.cdr.detectChanges();
        } else {
          // If there's no spec table data, reset the relevant properties.
          this.specProductHeaders = null;
          this.specProductValues = null;
          this.specTableData$.next(null);
        }
        return productLocalSKUCode;
      }),
      tap((productLocalSKUCode: any) => {
        if (productLocalSKUCode.length > 0) {
          this.getDealerPrices(productLocalSKUCode);
        }
      }),
      catchError((error) => {
        // Error catching and resetting the spec table data. Also, console the error.
        console.error('Error loading spec table data:', error);
        this.specTableData$.next(null);
        return of(null);
      })
    );
  }

  checkTableId(skuValues: any, headerValues: any): string {
    const headerValue = headerValues.headerId;
    let sku: any;
    skuValues.forEach((skuValue: any) => {
      if (skuValue.headerId === headerValue) {
        sku = skuValue.value;
      }
    });
    return sku;
  }

  dealerPrice(productCode: string): string {
    if (this.dealerPrices) {
      return this.dealerPriceService.getDealerPriceByProductCode(this.dealerPrices, productCode);
    }
  }

  getDealerPrices(productCodes: any[]) {
    this.dealerPriceService
      .getDealerPricesByProductCodes(productCodes)
      .pipe(take(1))
      .subscribe((data) => {
        this.dealerPrices = data.dealerPrices;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.specTableLoadersubscription$?.unsubscribe();
  }
}
